/*
 * @Author: duke
 * @Date: 2024-04-19 17:10:15
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import { Message } from 'element-ui'
let messageInstance = null;
// 重写message挂载,用法 ===>  $message('xxxx')  $message.info('xxxx')  $message.info({message:'xxx'}) 
const $message = options => {

  if (typeof options === 'string') {
    return Message({
      message: options,
      duration: 3000,
    })
  }
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message({
    ...options,
    duration: 3000,
  })
  return messageInstance
}

['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === Object) {
      options = {
        duration: 3000,
        type: type,
        ...options,
      }
    }

    if (typeof options === 'string') {
      options = {
        duration: 3000,
        type: type,
        message: options,
      }
    }
    return $message(options)
  }
})

export default $message